__turbopack_context__.v({
  "bold": "FinanceQuoteBreakdownModal-module-scss-module__bfVKha__bold",
  "container": "FinanceQuoteBreakdownModal-module-scss-module__bfVKha__container",
  "content": "FinanceQuoteBreakdownModal-module-scss-module__bfVKha__content",
  "contentHeader": "FinanceQuoteBreakdownModal-module-scss-module__bfVKha__contentHeader",
  "contentWrapper": "FinanceQuoteBreakdownModal-module-scss-module__bfVKha__contentWrapper",
  "description": "FinanceQuoteBreakdownModal-module-scss-module__bfVKha__description",
  "detailedBlock": "FinanceQuoteBreakdownModal-module-scss-module__bfVKha__detailedBlock",
  "discountContainer": "FinanceQuoteBreakdownModal-module-scss-module__bfVKha__discountContainer",
  "discountValue": "FinanceQuoteBreakdownModal-module-scss-module__bfVKha__discountValue",
  "divider": "FinanceQuoteBreakdownModal-module-scss-module__bfVKha__divider",
  "header": "FinanceQuoteBreakdownModal-module-scss-module__bfVKha__header",
  "introducerFeeBlock": "FinanceQuoteBreakdownModal-module-scss-module__bfVKha__introducerFeeBlock",
  "introducerFeeTitleBlock": "FinanceQuoteBreakdownModal-module-scss-module__bfVKha__introducerFeeTitleBlock",
  "logoImg": "FinanceQuoteBreakdownModal-module-scss-module__bfVKha__logoImg",
  "oldValues": "FinanceQuoteBreakdownModal-module-scss-module__bfVKha__oldValues",
  "price": "FinanceQuoteBreakdownModal-module-scss-module__bfVKha__price",
  "priceLayout": "FinanceQuoteBreakdownModal-module-scss-module__bfVKha__priceLayout",
  "root": "FinanceQuoteBreakdownModal-module-scss-module__bfVKha__root",
  "spaceBetween": "FinanceQuoteBreakdownModal-module-scss-module__bfVKha__spaceBetween",
  "textPadding": "FinanceQuoteBreakdownModal-module-scss-module__bfVKha__textPadding",
  "total": "FinanceQuoteBreakdownModal-module-scss-module__bfVKha__total",
  "vwfsInclude": "FinanceQuoteBreakdownModal-module-scss-module__bfVKha__vwfsInclude",
});
